var _excluded = ["sheetIndex"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import getSelfClosingTagMarkup from '../../../xml/getSelfClosingTagMarkup.js';
export default function generateViews(_ref) {
  var sheetIndex = _ref.sheetIndex,
    viewProperties = _objectWithoutProperties(_ref, _excluded);
  if (!hasView(viewProperties)) {
    return '';
  }
  var showGridLines = viewProperties.showGridLines,
    rightToLeft = viewProperties.rightToLeft,
    zoomScale = viewProperties.zoomScale;
  var views = '';
  var sheetViewAttributes = {
    tabSelected: sheetIndex === 0 ? 1 : 0,
    // The first sheet is selected by default.
    workbookViewId: 0
  };
  if (showGridLines === false) {
    sheetViewAttributes.showGridLines = false;
  }
  if (rightToLeft) {
    sheetViewAttributes.rightToLeft = 1;
  }
  if (typeof zoomScale === 'number') {
    // Convert the scale number to a percentage.
    //
    // Excel 2007 doesn't like fractional `zoomScale` percentage values.
    // To work around that, it rounds the resulting percentage value.
    //
    sheetViewAttributes.zoomScale = Math.round(zoomScale * 100);
  }
  views += '<sheetViews>';
  views += getSelfClosingTagMarkup('sheetView', sheetViewAttributes);
  views += '</sheetViews>';
  return views;
}
function hasView(_ref2) {
  var showGridLines = _ref2.showGridLines,
    rightToLeft = _ref2.rightToLeft,
    zoomScale = _ref2.zoomScale;
  return showGridLines === false || rightToLeft || typeof zoomScale === 'number';
}
//# sourceMappingURL=views.js.map